import React from 'react';
import { TenderDataType } from './SummaryTenderModal';
import { useQuery } from '@tanstack/react-query';
import { getTenderCigs } from '@lib/api';

interface SummaryTenderModalCigProps {
	tenderData: TenderDataType;
}

const SummaryTenderModalCig: React.FC<SummaryTenderModalCigProps> = ({ tenderData }) => {
	const { data: cigs } = useQuery<{ data: { id: number; cig: string; lot: string }[] }>({
		queryKey: ['tenderCig', tenderData.id],
		queryFn: () => getTenderCigs(tenderData.id),
		enabled: !!tenderData.id,
	});

	return (
		<div>
			{cigs?.data.length ? (
				cigs.data.map((cig) => (
					<div
						key={cig.id}
						style={{
							backgroundColor: '#EDF0F7',
							padding: '1rem',
							borderRadius: '8px',
							display: 'grid',
							gap: '1rem',
						}}
					>
						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between',
							}}
						>
							<div
								style={{
									fontWeight: 700,
								}}
							>
								Lotto
							</div>
							<div>{cig.lot}</div>
						</div>
						<div
							style={{
								display: 'flex',
								justifyContent: 'space-between',
							}}
						>
							<div
								style={{
									fontWeight: 700,
								}}
							>
								Codice
							</div>
							<div>{cig.cig}</div>
						</div>
					</div>
				))
			) : (
				<p>Nessun CIG associato a questa gara.</p>
			)}
		</div>
	);
};

export default SummaryTenderModalCig;
